<template>
  <div id="app" class="layout-patricia">
    <div class="bg">
      <div class="sky">
        <div class="cloud"></div>
      </div>
      <div class="ground"></div>
    </div>
    <header>
      <div class="logo">
        <img src="../assets/logo__24011701.svg" />
      </div>
      <i
        class="material-icons nav-opener"
        :class="{ open: navOpen }"
        @click="navOpen = !navOpen"
        >menu</i
      >
      <div class="facts">
        <h1>Team Area</h1>
      </div>
      <div class="actions-wrapper">
        <div class="actions"></div>
      </div>
    </header>
    <main>
      <aside>
        <nav :class="{ open: navOpen }">
          <!--
          TODO: Implement permission system to only allow certain members access to personal data.
          <router-link :to="{ name: 'newsletterAdmin' }"
            >Newsletter</router-link
          >
          -->
          <router-link :to="{ name: 'ticketRequestAdmin' }"
            >Ticket Klicks</router-link
          >
          <router-link :to="{ name: 'pageReloadAdmin' }"
            >Page Reloads</router-link
          >
          <router-link :to="{ name: 'quotasAdmin' }">Quotas</router-link>
        </nav>
      </aside>
      <div class="content" id="main-content">
        <router-view></router-view>
      </div>
    </main>
    <footer>
      &copy; 2019-2023 Alle Rechte vorbehalten. <br />
      <router-link class="silent" :to="{ name: 'impressum' }"
        >Impressum</router-link
      >
      |
      <router-link class="silent" :to="{ name: 'privacy' }"
        >Datenschutz</router-link
      >
      |
      <a class="silent" :href="authURL">Teamlogin</a>
    </footer>
    <div class="profile" v-if="user">
      <div
        class="avatar"
        :style="{ backgroundImage: `url(${user.avatar_url})` }"
      ></div>
      <label>{{ user.name }}</label>
      <button @click="logout"><i class="material-icons">logout</i></button>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      now: new Date(),
      navOpen: false,
      authURL: process.env.VUE_APP_AUTH_URL,
      user: null,
    };
  },
  created() {
    window.setInterval(() => {
      this.now = new Date();
    }, 300);
  },
  mounted() {
    this.authenticate();
  },
  methods: {
    activateTwitter(e) {
      if (!this.twitterActive) {
        if (
          confirm(
            "Durch die Aktivierung des Tweet-Buttons werden Cookies von Twitter gespeichert. Forfahren?"
          )
        ) {
          window.twttr = (function (d, s, id) {
            var js,
              fjs = d.getElementsByTagName(s)[0],
              t = window.twttr || {};
            if (d.getElementById(id)) {
              return t;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function (f) {
              t._e.push(f);
            };

            return t;
          })(document, "script", "twitter-wjs");
          this.twitterActive = true;
        }
        e.stopPropagation();
        return false;
      }
    },
    authenticate() {
      const credentials = JSON.parse(localStorage.getItem("API_CREDENTIALS"));
      if (credentials) {
        axios
          .get(`${process.env.VUE_APP_API}/auth/profile`, {
            headers: {
              Authorization: `Bearer ${credentials.auth.access_token}`,
            },
            params: {
              id: credentials.info.resource_owner_id,
            },
          })
          .then((response) => {
            this.user = response.data;
          });
      }
    },
    logout() {
      const credentials = JSON.parse(localStorage.getItem("API_CREDENTIALS"));
      axios
        .post(`${process.env.VUE_APP_API}/auth/logout`, {
          token: credentials.auth.access_token,
        })
        .then((response) => {
          this.user = null;
          localStorage.removeItem("API_CREDENTIALS");
          this.$router.go();
        });
    },
  },
  watch: {
    $route() {
      // Whenever route changes, close the mobile nav, i.e. user clicked a link
      this.navOpen = false;
      this.authenticate();
    },
  },
};
</script>

<style lang="scss" scoped>
div.layout-patricia {
  $colorMain: #f06292;
  $colorAccent: #fdd835;
  $mobileSize: 1000px;

  a.button,
  button {
    background: $colorAccent;
    border-radius: 4px;
    padding: 5px 10px;
    border: 2px solid $colorAccent;
    font: inherit;
    font-weight: bold;
    box-shadow: 0 2px 6px rgba(#000, 0.4);
    transition: box-shadow 200ms ease-in-out;
    cursor: pointer;

    &.silent {
      background: transparent;
      color: black;
      box-shadow: none;
      border-color: #ddd;

      &:hover {
        border-color: #aaa;
        background: #aaa;
        box-shadow: none;
        color: white;
      }
    }

    &:hover {
      //background: darken($colorAccent, 15);
      box-shadow: 0 6px 12px rgba(#000, 0.4);
    }

    &:before {
      display: none;
    }

    &:disabled {
      background: transparent;
      color: $colorAccent;
      border-style: dashed;
      box-shadow: none;
      cursor: not-allowed;
    }

    &.active {
      background: white;
    }
  }

  a {
    color: black;
    background: lighten($colorAccent, 30);
    text-decoration: none;
    display: inline-block;
    padding: 0 0.5em;
    position: relative;

    &:hover {
      background: $colorAccent;
      color: black;
    }

    &:before {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border: 2px solid $colorAccent;
      border-radius: 4px;
    }

    &[href*="//"]
    {
      &:after {
        content: " →";
      }
    }

    &.silent {
      padding: 0;
      background: none;
      color: inherit;
      cursor: pointer;

      &:before {
        display: none;
      }

      &:after {
        display: none;
      }
    }
  }

  input,
  textarea,
  select {
    border-radius: 4px;
    border: 0;
    padding: 5px 10px;
    font: inherit;
    box-shadow: 0 2px 6px rgba(#000, 0.4);

    &:focus {
      box-shadow: 0 6px 12px rgba(#000, 0.4);
    }
  }

  label {
    padding: 5px 0;
  }

  input[type="checkbox"] {
    appearance: none;
    display: inline-block;
    background: white;
    width: 30px;
    height: 30px;
    margin: 0;
    border: 2px solid white;
    position: relative;

    &:checked {
      &:after {
        content: "check";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: "Material Icons";
        font-weight: bold;
        font-size: 20px;
      }
    }
  }

  .bg {
    position: fixed;
    z-index: -1;
    background: $colorMain;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  & {
    max-width: 1400px;
    margin: 0 auto;
    font: 16px "Open Sans", sans-serif;
    color: white;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      text-transform: uppercase;
      font-family: "Proxima Nova", "proxima_nova", sans-serif;
      margin-top: 2em;

      &:first-child {
        margin-top: 0;
      }

      .subtitle {
        font-size: 60%;
        display: block;
      }
    }

    p {
      &:last-child {
        margin-bottom: 0;
      }

      &:first-child {
        margin-top: 0;
      }
    }

    div.error {
      padding: 20px;
      background: #b71c1c;
      color: white;
      border-radius: 8px;
      margin: 20px 0;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    div.success {
      background: #1b5e20;
      color: white;
    }

    ul {
      li {
        margin: 1em 0;
      }
    }

    > header {
      padding: 40px 20px 40px 60px;
      color: white;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      position: relative;

      > * {
        padding-top: 10px;

        &.logo {
          padding-top: 0;
        }
      }

      .actions-wrapper {
        text-align: right;
      }

      .actions {
        display: flex;
        align-items: center;
        justify-content: center;

        a.button {
          margin: 10px 10px 10px 0px;

          &:last-child {
            margin-right: 0;
          }
        }
      }

      @media screen and (max-width: $mobileSize) {
        display: block;
        text-align: center;
        padding: 40px 20px;

        .facts {
          padding: 30px 0;
          font-size: 10px;
        }

        .logo {
          display: inline-block;
        }

        .actions {
          text-align: center;

          a.button {
            display: block;
            margin: 10px 0;
          }
        }
      }

      .logo {
        height: 100px;

        @media screen and (max-width: $mobileSize) {
          height: auto;
          width: 100%;
        }

        img {
          height: 100%;
        }
      }

      .nav-opener {
        display: none;
        position: fixed;
        z-index: 100;
        top: 0;
        right: 0;
        padding: 20px;

        &.open {
          color: black;
        }

        @media screen and (max-width: $mobileSize) {
          display: block;
        }
      }
    }

    .flyer {
      padding: 20px 60px;

      @media screen and (max-width: 1000px) {
        padding: 20px 0;
        text-align: center;
      }

      img {
        width: 100%;

        @media screen and (max-width: 1000px) {
          width: auto;
          height: 400px;
        }
      }

      > * {
        transform: rotate(-5deg);

        @media screen and (max-width: $mobileSize) {
          transform: none;
        }
      }
    }

    .bold-note {
      padding: 20px;
      background: gray;
      color: white;
      border-radius: 8px;
    }

    > main {
      display: grid;
      grid-template-columns: 400px auto;
      padding-bottom: 60px;

      @media screen and (max-width: $mobileSize) {
        display: block;
      }
    }

    > footer {
      text-align: center;
      padding: 40px 0;
      font-size: 12px;
    }

    > main .content {
      padding: 20px;

      article {
        color: black;
        background: $colorAccent;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 6px 12px rgba(#000, 0.2);
        border: 4px solid $colorAccent;
        margin-bottom: 40px;

        &.secondary {
          border-color: gray;
          background: gray;

          header {
            background: gray;
            color: white;
          }
        }

        header {
          background-color: $colorAccent;
          text-transform: uppercase;
          box-sizing: border-box;
          position: relative;

          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          p {
            margin: 0;
            padding: 0;
          }
        }

        header,
        main {
          padding: 20px;
        }

        main {
          border-radius: 4px;
          background: white;
        }

        &.newsletter {
          header {
            margin-top: 24px;
            margin-bottom: 24px;
          }

          header:before {
            $colorAccentBg: #fff;
            content: "";
            display: block;
            position: absolute;
            bottom: -20px;
            height: 20px;
            left: 0;
            right: 0;
            width: 100%;
            border-radius: 4px;
            box-sizing: border-box;
            background: repeating-linear-gradient(
              -55deg,
              $colorAccent,
              $colorAccent 10px,
              $colorAccentBg 10px,
              $colorAccentBg 20px
            );
            border: 0px solid $colorAccentBg;
          }

          header:after {
            $colorAccentBg: #fff;
            content: "";
            display: block;
            position: absolute;
            top: -24px;
            height: 20px;
            left: 0;
            right: 0;
            width: 100%;
            border-radius: 4px;
            box-sizing: border-box;
            background: repeating-linear-gradient(
              -55deg,
              $colorAccent,
              $colorAccent 10px,
              $colorAccentBg 10px,
              $colorAccentBg 20px
            );
            border: 0px solid $colorAccentBg;
          }
        }
      }
    }

    > main aside {
      .partners {
        padding: 40px;
        transform: rotate(-5deg);

        @media screen and (max-width: $mobileSize) {
          transform: none;
          background: $colorMain;
          margin: 10px 0;
        }
      }

      .partner-links {
        display: flex;
        width: 100%;
        box-sizing: border-box;

        a {
          display: flex;
          justify-content: center;
          background-color: white;
          border-radius: 8px;
          overflow: hidden;
          width: 100%;
          margin-left: 20px;
          padding: 20px;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);

          &:first-child {
            margin-left: 0;
          }

          img {
            max-width: 100%;
            align-self: center;
          }
        }
      }

      nav {
        width: 75%;
        padding-top: 60px;
        padding-left: 40px;

        @media screen and (max-width: $mobileSize) {
          opacity: 0;
          position: fixed;
          top: 0;
          left: 0;
          height: 100%;
          z-index: 10;
          background: white;
          width: 100%;
          box-sizing: border-box;
          padding: 20px;
          transition: padding-top 200ms ease-in-out,
            max-height 200ms ease-in-out, opacity 200ms ease-in-out;
          max-height: 0;
          overflow: auto;

          &.open {
            opacity: 1;
            display: block;
            padding-top: 60px;
            max-height: 2000px;
          }
        }

        a {
          background: transparent;
          text-decoration: none;
          font-size: 20px;
          color: white;
          display: block;
          text-transform: uppercase;
          font-weight: bold;
          padding: 20px 0;
          transform: rotate(-5deg);
          padding-left: 70px;
          border-radius: 8px;
          font-family: "Proxima Nova", sans-serif;

          @media screen and (max-width: $mobileSize) {
            transform: none;
            background: $colorMain;
            margin: 10px 0;
          }

          &:before {
            display: none;
          }

          &[disabled] {
            opacity: 0.5;
            color: black;
            cursor: default;
          }

          .material-icons {
            position: absolute;
            top: 20px;
            left: 20px;
            bottom: 20px;
            width: 30px;
            //background: red;
          }

          &.router-link-active {
            position: relative;
            background: white;
            color: black;
            box-shadow: 0 2px 6px rgba(#000, 0.6);

            @media screen and (max-width: $mobileSize) {
              background: $colorAccent;
              color: black;
            }
          }
        }
      }
    }
  }

  .profile {
    position: fixed;
    background: white;
    bottom: 20px;
    right: 20px;
    box-shadow: 0 2px 6px rgba(black, 0.6);
    border-radius: 6px;
    color: black;
    display: flex;
    overflow: hidden;
    align-items: center;

    .avatar {
      height: 40px;
      width: 40px;
      background-repeat: no-repeat;
      background-size: contain;
    }

    label {
      padding: 10px;
      border-right: 1px solid #ddd;
      border-left: 1px solid #ddd;
    }

    button {
      background: white;
      border-radius: 0;
      border: 0;
      box-shadow: none;
      display: flex;
      align-items: center;
    }
  }

  .language-select {
    a.selected {
      font-weight: bold;

      &:after {
        content: "";
        position: absolute;
        bottom: -3px;
        height: 3px;
        background: white;
        width: 100%;
        display: block;
      }
    }
  }
}
</style>
